import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  CircularProgress,
} from '@mui/material';
import TelegramIcon from '@mui/icons-material/Telegram';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import Pusher from 'pusher-js';

const Login = () => {
  const [error, setError] = useState('');
  const [telegramLoading, setTelegramLoading] = useState(false);
  const [telegramLink, setTelegramLink] = useState(null);
  const [authHash, setAuthHash] = useState(null);
  const { loginWithTelegram } = useAuth();
  const navigate = useNavigate();

  const handleTelegramLogin = async () => {
    setError('');
    setTelegramLoading(true);

    try {
      const response = await axios.post('/api/auth/telegram/generate-link');

      setTelegramLink(response.data.link);
      setAuthHash(response.data.hash);

      // Подключаемся к Pusher для получения события авторизации
      const pusher = new Pusher('d67cc950a721a71cb34e', {
        cluster: 'eu',
      });

      const channel = pusher.subscribe('auth');
      channel.bind('telegram-authenticated', async (data) => {
        if (data.hash === response.data.hash) {
          pusher.disconnect();
          
          // Проверяем статус авторизации
          const statusResponse = await axios.get(`/api/auth/telegram/status/${data.hash}`);
          
          if (statusResponse.data.authenticated) {
            await loginWithTelegram(statusResponse.data.token, statusResponse.data.user);
            navigate('/dashboard');
          }
        }
      });

      // Также делаем polling на случай, если Pusher не сработает
      const pollInterval = setInterval(async () => {
        try {
          const statusResponse = await axios.get(`/api/auth/telegram/status/${response.data.hash}`);
          if (statusResponse.data.authenticated) {
            clearInterval(pollInterval);
            pusher.disconnect();
            await loginWithTelegram(statusResponse.data.token, statusResponse.data.user);
            // Если фамилия не заполнена, перенаправляем на профиль
            if (!statusResponse.data.user.last_name) {
              navigate('/profile');
            } else {
              navigate('/dashboard');
            }
          }
        } catch (err) {
          console.error('Polling error:', err);
        }
      }, 2000);

      // Останавливаем polling через 10 минут
      setTimeout(() => {
        clearInterval(pollInterval);
        pusher.disconnect();
      }, 600000);
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка генерации ссылки');
      setTelegramLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
          <Typography variant="h4" component="h1" gutterBottom align="center">
            Вход
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          {telegramLink ? (
            <Box sx={{ textAlign: 'center' }}>
              <Alert severity="info" sx={{ mb: 2 }}>
                Перейдите по ссылке для авторизации через Telegram
              </Alert>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                startIcon={<TelegramIcon />}
                href={telegramLink}
                target="_blank"
                sx={{ mb: 2 }}
              >
                Открыть Telegram
              </Button>
              <Typography variant="body2" color="text.secondary">
                Ожидание авторизации...
              </Typography>
              {telegramLoading && (
                <Box sx={{ mt: 2 }}>
                  <CircularProgress size={24} />
                </Box>
              )}
            </Box>
          ) : (
            <Button
              fullWidth
              variant="contained"
              color="primary"
              startIcon={<TelegramIcon />}
              onClick={handleTelegramLogin}
              disabled={telegramLoading}
              sx={{ mt: 3, mb: 2 }}
            >
              {telegramLoading ? 'Генерация ссылки...' : 'Войти через Telegram'}
            </Button>
          )}
        </Paper>
      </Box>
    </Container>
  );
};

export default Login;
